<template>
<div></div>
</template>

<script>
import '../styles/map-info-window.scss'

import Vue from 'vue'
import { addParamToTpl } from '../utils/tpl'

export default {
    props: {
        values: {
            default: [],
        },
        hoveredKey: {
            type: String,
            _descr: 'Id of location to highlight',
        },
        googleMapsKey: {
            type: String,
            _descr: 'Google Maps API key',
        },
        tplComponent: {
            default () {
                return require('./tpl.vue').default
            },
        },
    },
    data () {
        return {
            inited: false,
            map: null,
            info: null,
        }
    },
    mounted () {
        let init = () => {
            const TRANSITION_TIME = 200 // Temp hack, waiting for uncollapsed stage. DEV2-2079
            setTimeout(() => {
                this.map = new window.google.maps.Map(this.$el, {
                    scrollwheel: false,
                    zoom: this.$root.appConfig.mapMinZoom,
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    styles: this.$root.appConfig.googleMapsStyles,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: window.google.maps.ControlPosition.LEFT_TOP,
                    },
                })

                this.info = new window.google.maps.InfoWindow({
                    maxWidth: 240,
                })

                window.google.maps.event.addListenerOnce(this.map, 'idle', () => {
                    this.inited = true
                })
            }, TRANSITION_TIME)
        }

        if (window.google && window.window.google.maps) {
            init()
        } else {
            let tryLoadMap = () => {
                this.loadMap().then(init).catch(tryLoadMap)
            }

            tryLoadMap()
        }
    },
    computed: {
        markers () {
            if (!this.map || !this.inited) {
                return []
            }

            let defineMarker = modificator => ({
                url: require(`../assets/img/marker${modificator ? '_' + modificator : ''}.png`),
                scaledSize: new window.google.maps.Size(21, 30),
                size: new window.google.maps.Size(21, 30),
                origin: new window.google.maps.Point(0, 0),
                labelOrigin: new window.google.maps.Point(11, 10),
                anchor: new window.google.maps.Point(11, 30),
            })

            let markerImage = {
                multi: defineMarker(),
                single: defineMarker('single'),
                multiHover: defineMarker('red'),
                singleHover: defineMarker('single_red'),
            }

            return this.values.map(location => {
                if (!location.id || !location.map) {
                    return
                }

                let marker = {
                    items: location.items,
                }

                marker.latitude = parseFloat(location.map.position.latitude)
                marker.longitude = parseFloat(location.map.position.longitude)

                marker.instance = new window.google.maps.Marker({
                    position: {
                        lat: marker.latitude,
                        lng: marker.longitude,
                    },
                    icon: marker.items.length > 1 ? markerImage.multi : markerImage.single,
                    label: {
                        text: marker.items.length > 1 ? String(marker.items.length) : ' ',
                        color: 'white',
                        fontSize: '11px',
                    },
                })

                marker.instance.addListener('click', () => {
                    let addContextAttrs = template => {
                        template = addParamToTpl(template, 'context-one', 'value', marker.items.length === 1)
                        template = addParamToTpl(template, 'context-multiple', 'value', marker.items.length !== 1)

                        return template
                    }

                    let id = `mapinfot${new Date().getTime()}`
                    this.info.setContent(`<div id="${id}"></div>`)
                    this.info.open(this.map, marker.instance)
                    this.$nextTick(() => { // awaits for map info to be opened
                        // eslint-disable-next-line no-new
                        new Vue({
                            store: this.$store,
                            el: document.getElementById(id),
                            template: `<div class="odr-map-info-window"><tpl :escaped="true" content="${escape(addContextAttrs(location.map.info))}"></tpl></div>`,
                            components: {
                                tpl: this.tplComponent,
                            },
                        })
                    })
                })

                marker.focus = () => { marker.instance.setIcon(marker.items.length > 1 ? markerImage.multiHover : markerImage.singleHover) }
                marker.blur = () => { marker.instance.setIcon(marker.items.length > 1 ? markerImage.multi : markerImage.single) }

                window.google.maps.event.addListener(marker.instance, 'mouseover', () => { marker.focus() })
                window.google.maps.event.addListener(marker.instance, 'mouseout', () => { marker.blur() })

                return marker
            }).filter(marker => !!marker)
        },
    },
    watch: {
        markers (newMarkers, oldMarkers) {
            oldMarkers.forEach(marker => {
                marker.instance.setMap(null)
            })
            newMarkers.forEach(marker => {
                marker.instance.setMap(this.map)
            })

            this.zoomToMarkers(newMarkers)
        },
        hoveredKey (newHovered, oldHovered) {
            if (newHovered) {
                this.markers.filter(marker => marker.items.includes(newHovered)).forEach(marker => {
                    marker.focus()
                })
            }

            this.markers.filter(marker => marker.items.includes(oldHovered)).forEach(marker => {
                marker.blur()
            })
        },
    },
    methods: {
        zoomToMarkers (markers) {
            if (!this.map) {
                return
            }
            let bounds = new window.google.maps.LatLngBounds()

            markers.forEach(marker => {
                bounds.extend(new window.google.maps.LatLng(marker.latitude, marker.longitude))
            })

            this.map.fitBounds(bounds)
            this.map.panToBounds(bounds)

            if (this.map.getZoom() > this.$root.appConfig.mapMinZoom) {
                this.map.setZoom(this.$root.appConfig.mapMinZoom)
            }
        },
        loadMap () {
            let script = document.createElement('script')

            return new Promise((resolve, reject) => {
                const key = `map${new Date().getTime()}`
                window[key] = () => {
                    resolve()
                }
                script.setAttribute('async', 'async')
                script.setAttribute('defer', 'defer')
                script.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.googleMapsKey || this.$root.appConfig.googleMapsKey}&callback=${key}&language=en`)

                document.body.appendChild(script)

                script.onerror = () => {
                    reject(new Error('Script Error'))
                    script.remove()
                }
            })
        },
    },
}
</script>
